import {Api} from "./api"

export default class AlertApi extends Api {
    constructor() {
        super("/alert");
    }

    async getAlerts(serviceID: number) {
        return await this.call("/list_alert", {serviceID})
    }

    async addAlert(alertName: string, alertDescription: string, projectID: number, serviceID: number, level: number, status: number, userGroupIDS: number[], keyWords: string[], badkeys: string[], weight: number) {
        return await this.call("/add_alert", {
            alertName,
            alertDescription,
            projectID,
            serviceID,
            level,
            status,
            userGroupIDS,
            keyWords,
            badkeys,
            weight
        });
    }

    async deleteAlert(alertID: number) {
        return await this.call("/delete_alert", {alertID});
    }

    async getAlert(alertID: number) {
        return await this.call("/get_alert", {alertID});
    }

    async updateAlert(alertID: number, alertName: string, alertDescription: string, level: number, status: number, userGroupIDS: number[], keyWords: string[], badkeys: string[], weight: number) {
        return await this.call("/update_alert", {
            alertID,
            alertName,
            alertDescription,
            level,
            status,
            userGroupIDS,
            keyWords,
            badkeys,
            weight
        });
    }
}